import React, { useContext, useState } from 'react';
import RefundDetailsForm from './RefundDetailsForm';
import RefundItems from './refundItems';
import UploadDocuments from './UploadDocuments';
import Footer from '../../../../studentTransfer/components/Footer';
import AButton from '../../../../../views/pages/manage/common/form-fields-mui/AButton';
import { useWizard } from '../../../../../components/wizard/WizardContext';
import { CONCESSION_REFUND, DISCRETIONARY_REFUND, FULL_REFUND, SECURITY_REFUND, studentDetailsLabelFieldMapping, useGetAdditionalStudentDetails, useGetMultiTypeRefundStep2Utils, useGetStudentAndVendorAccountDetails, WITHDRAWAL_REFUND , useAutoFillRefundDetailsForRefundEdit, fetchPayableRefundInfo, multiTypeRefundDetailsEmptyForm, REFUND_VALIDATIONS_BYPASS_ROLES} from '../utils';
import ALoader from '../../../../../views/pages/manage/common/a-loader';
import StudentDetails from './StudentDetails';
import { formattedPrice } from '../../../../../views/pages/manage/unAssigned/collectPayment/utils';
import { useSaveDataToConfigValues } from '../../rectificationRefund/selectRefundReasonAndReceipt/utils';
import ABanner from '../../../../../components/ABanner';
import WarningIcon from "assets/img/svg/svgComponents/WarningIcon";
import moment from 'moment';
import { failureToast } from '../../../../../views/pages/manage/common/utils/methods/toasterFunctions/function';
import { PermissionContext } from '../../../../../appContext';
import { isLatestTransferAppIdDiscontinued} from '../../searchStudent/constants';
import { useBuTypeNameByBuId } from "modules/paymentManagement/cash-management/hooks/useFetchBuType";
import useValidateStdOutView from '../../../../../hooks/useValidateStdOutView';

const SelectRefundItems = () => {

  const permissions = useContext(PermissionContext);
    
  const bypassValidationsForRole = REFUND_VALIDATIONS_BYPASS_ROLES?.includes(permissions?.roleType);

  const { next, values, dropdowns, params } = useWizard();

  const forRefundEdit = params?.mode === 'edit';

  const { multiTypeRefundStep2Data, selectedStudent, multiTypeRefundUtils } = values;
  const { additionalStudentDetails } = multiTypeRefundStep2Data;
  const studentDetails = {
    ...selectedStudent,
    ...additionalStudentDetails
  }

  const { studentLoanDetails = {}, coursePricingDetails = {}, academicCareerValue} = studentDetails;
  const { isLoanCase } = studentLoanDetails;

  const { buTypeName, loading:isLoading } = useBuTypeNameByBuId(studentDetails?.businessAreaDispVal || null);
  const isFranchiseBuType = buTypeName?.toLowerCase() === 'franchise';


  const isDLPCase = academicCareerValue === 'DLP';

  console.log('studentLoanDetails', studentLoanDetails, 'studentDetails', studentDetails);

  const { refundReasons } = multiTypeRefundUtils;

  const [refundDetailsForm, setRefundDetailsForm] = useState(multiTypeRefundStep2Data?.refundDetailsForm);
  const [payableRefundInfo, setPayableRefundInfo] = useState(multiTypeRefundStep2Data?.payableRefundInfo);
  const [selectedRefundItems, setSelectedRefundItems] = useState(multiTypeRefundStep2Data?.selectedRefundItems);
  const [showFullRefundItem, setShowFullRefundItem] = useState(multiTypeRefundStep2Data?.showFullRefundItem);
  const [showDISCWarningBanner, setShowDISCWarningBanner] = useState(false);
  const [loading, setLoading] = useState(false);
  console.log('multiTypeRefundStep2Data', selectedRefundItems);
  const refundItemCheckboxHandler = (refundItem, checked, deSelectOthers = false) => {
    if (checked) {
    
      if (deSelectOthers) setSelectedRefundItems([refundItem])
      else setSelectedRefundItems(items => [...items, refundItem]);

    } else {
      setSelectedRefundItems(items => items?.filter(el => el !== refundItem))
    }


  }
  console.log('selectedRefundItems', selectedRefundItems);

  const handleRefundDetailsForm = (key, value, refundItemType) => {

    setRefundDetailsForm(prevForm => {
      if (!refundItemType) return { ...prevForm, [key]: value };

      return {
        ...prevForm,
        [refundItemType]: {
          ...prevForm[refundItemType],
          [key]: value
        }
      };
    });
  };

  const proceedNextHandler = async () => {

    try {
      //validation 1
      const { refundApplicationDate, batchEndDate } = refundDetailsForm;
      const isAfterTwoMonths = moment(refundApplicationDate).isAfter(
        moment(batchEndDate).add(2, "months")
      );

      if (!isFranchiseBuType && !bypassValidationsForRole && isAfterTwoMonths) {
        failureToast(
          "Multi-type refund not allowed as more than 2 months have passed since the course end date. Please contact HO Refund."
        );
        return;
      }

      //validation 2
      const { programAction, transferApplicationId = null, psid, applicationId } = studentDetails;
      if (
        !selectedRefundItems?.includes(CONCESSION_REFUND) && //no other refund cannot be raised with concession refund
        programAction !== 'DISC'
      ) {

        setLoading(true);

        if (
          !transferApplicationId ||
          !(await isLatestTransferAppIdDiscontinued(psid, applicationId, dropdowns))
        ) {
          setShowDISCWarningBanner(new Date());
          window.scrollTo({ top: 0, behavior: "smooth" });
          return;

        }

      }

      next();
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }

  const getRefundInfoClickHandler = async ({
    form = refundDetailsForm,
    resetRefundItemsForm = true
}) => {
    try {
        setLoading(true);
        const payableRefundInfo = await fetchPayableRefundInfo(studentDetails, form);
        setPayableRefundInfo(payableRefundInfo);

        if(resetRefundItemsForm){
          setRefundDetailsForm(prev => ({
            ...prev,
            ...multiTypeRefundDetailsEmptyForm()
          }))
        }

        //in case of withdrawal, the system decides the bifurcation of amount between parent and loan vendor, in case of RCC only
        if(!isDLPCase){
        const { refundableAmountToParent, refundableAmountToLoanVendor } = payableRefundInfo?.[WITHDRAWAL_REFUND] ?? {};
        handleRefundDetailsForm("payableToParent", refundableAmountToParent, WITHDRAWAL_REFUND);
        handleRefundDetailsForm("payableToVendor", refundableAmountToLoanVendor, WITHDRAWAL_REFUND);
        }

        //in case of security refund, the whole amount goes the parent
        const { totalRefundableAmount } = payableRefundInfo?.[SECURITY_REFUND] ?? {};
        handleRefundDetailsForm("payableToParent", totalRefundableAmount, SECURITY_REFUND)

    } catch (err) {
        console.error(err);
    } finally {
        setLoading(false);
    }
}



  const { totalAmountToRefund, allRequiredFieldsEntered, totalPayableToParent, totalPayableToVendor } = (() => {
    let totalAmountToRefund = 0;
    let totalPayableToParent = 0;
    let totalPayableToVendor = 0;
    let allRequiredFieldsEntered = selectedRefundItems?.length > 0;

    selectedRefundItems.forEach(item => {
      const { reason, payableToParent, payableToVendor, parentAttachmentKey, loanAttachmentKey } = refundDetailsForm[item];

      const numPayableToParent = +payableToParent;
      const numPayableToVendor = +payableToVendor;
      
      totalPayableToParent += numPayableToParent;
      totalPayableToVendor += numPayableToVendor;
      totalAmountToRefund += (numPayableToParent + numPayableToVendor);

      allRequiredFieldsEntered = Boolean(allRequiredFieldsEntered && (numPayableToParent || numPayableToVendor) && reason);

      if (
        (numPayableToParent && !parentAttachmentKey) ||
        (numPayableToVendor && !loanAttachmentKey)
      ) {
        allRequiredFieldsEntered = false;
      }

      if(
        isDLPCase && 
        item === WITHDRAWAL_REFUND &&
        refundDetailsForm?.dlpWithdrawalRefundDetails?.totalRefundPercentage !== 100
      ){
        allRequiredFieldsEntered = false;
      }
    })

    return { totalAmountToRefund, allRequiredFieldsEntered, totalPayableToParent, totalPayableToVendor}
  })();

  console.log('refundDetailsForm', refundDetailsForm, totalAmountToRefund);

  useGetAdditionalStudentDetails(setLoading, handleRefundDetailsForm);
  useGetStudentAndVendorAccountDetails(setLoading);
  useGetMultiTypeRefundStep2Utils();

  useAutoFillRefundDetailsForRefundEdit({
    setSelectedRefundItems,
    setRefundDetailsForm,
    // setLoading,
    // setPayableRefundInfo,
    // handleRefundDetailsForm,
    selectedRefundItems,
    getRefundInfoClickHandler
  })

  const isFullRefund = selectedRefundItems?.includes(FULL_REFUND);
  const isConcessionRefund = selectedRefundItems?.includes(CONCESSION_REFUND);

  const refundItems = forRefundEdit 
  ? selectedRefundItems 
  : [
    ...(showFullRefundItem ? [FULL_REFUND] : []),
    SECURITY_REFUND,
    WITHDRAWAL_REFUND,
    DISCRETIONARY_REFUND,
    CONCESSION_REFUND
  ]

  const dataToSaveToConfig = {
    selectedStudentAppId: selectedStudent?.applicationId,
    additionalStudentDetails,
    refundDetailsForm,
    payableRefundInfo,
    selectedRefundItems,
    isFullRefund,
    isConcessionRefund,
    totalAmountToRefund,
    showFullRefundItem,
    totalPayableToParent,
    totalPayableToVendor,
    isDLPCase,
    isFranchiseBuType
  }

  useSaveDataToConfigValues(dataToSaveToConfig, "multiTypeRefundStep2Data");

  const { checkingStdOutValidity } = useValidateStdOutView({
    bu: selectedStudent?.businessAreaDispVal,
    psid: selectedStudent?.psid,
    applicationId: selectedStudent?.applicationId
  })

  return (

    <div className='m-2 d-flex flex-column' style={{ gap: '1.5rem' }}>

      {(checkingStdOutValidity || loading || multiTypeRefundUtils?.loading || isLoading) && <ALoader position={"fixed"} />}

      <ABanner
        infoIcon={WarningIcon}
        isShow={showDISCWarningBanner}
        bgColor='#FFEDC8'
        txtColor='#705010'
        msg={"Student should be DISC to proceed further."}
      />

      <StudentDetails
        studentDetails={studentDetails}
        labelFieldMappings={studentDetailsLabelFieldMapping(studentDetails, dropdowns?.data)}
      />

      <RefundDetailsForm
        form={refundDetailsForm}
        studentDetails={studentDetails}
        // setForm={setRefundDetailsForm}
        // setPayableRefundInfo={setPayableRefundInfo}
        // setLoading={setLoading}
        handleForm={handleRefundDetailsForm}
        studentLoanDetails={studentLoanDetails}
        coursePricingDetails={coursePricingDetails}
        forRefundEdit={forRefundEdit}
        getRefundInfoClickHandler={getRefundInfoClickHandler}
        bypassValidationsForRole={bypassValidationsForRole}
        buTypeName={buTypeName}
        isDLPCase={isDLPCase}
        isFranchiseBuType={isFranchiseBuType}
      />

      {payableRefundInfo &&
        <RefundItems
          refundItems={refundItems}
          payableRefundInfo={payableRefundInfo}
          refundDetailsForm={refundDetailsForm}
          setRefundDetailsForm={setRefundDetailsForm}
          selectedRefundItems={selectedRefundItems}
          setSelectedRefundItems={setSelectedRefundItems}
          refundItemCheckboxHandler={refundItemCheckboxHandler}
          handleRefundDetailsForm={handleRefundDetailsForm}
          isFullRefund={isFullRefund}
          isConcessionRefund={isConcessionRefund}
          refundReasons={refundReasons}
          isLoanCase={isLoanCase}
          totalAmountToRefund={totalAmountToRefund}
          setShowFullRefundItem={setShowFullRefundItem}
          studentDetails={studentDetails}
          setLoading={setLoading}
          forRefundEdit={forRefundEdit}
          isDLPCase={isDLPCase}
        />
      }

      <Footer>
        <div>{selectedRefundItems?.length} Refund item{selectedRefundItems?.length > 1 && "s"} • Amount {formattedPrice(totalAmountToRefund)}</div>
        <AButton
          onClick={proceedNextHandler}
          className="button_remove_left_margin"
          variant="primary_filled"
          disabled={!allRequiredFieldsEntered}
        >
          Proceed next
        </AButton>
      </Footer>

    </div>
  );
}

export default SelectRefundItems;